import { Injectable, signal } from '@angular/core';
import { COUNTRY_CODE } from '@core/enums';
import { ICountryMask } from '@core/interface';

@Injectable({
  providedIn: 'root'
})
export class MasksService {
  cityCodeDisabled = [COUNTRY_CODE.CHILE, COUNTRY_CODE.PERU, COUNTRY_CODE.ECUADOR];
  disabledAllFieldsPhone = signal<boolean>(false);
  isDisabledCityCode = signal<boolean>(false);

  active = signal<boolean>(false);
  masksSignal = signal<ICountryMask | null>(null);

  setMasks(masks: ICountryMask): void {
    const { useMaskCityCodeToPhone } = masks;
    const masksFormatted = this.formatMask(masks);
    this.masksSignal.set(masksFormatted);
    this.active.set(true);
    this.disabledAllFieldsPhone.set(useMaskCityCodeToPhone === 'true');
    this.isDisabledCityCode.set(this.isDisabledCityCodeByCountry(sessionStorage.getItem('country') || ''));
    sessionStorage.setItem('masks', JSON.stringify(masksFormatted));
  }

  /*
  * Format mask
  * @param masks ICountryMask
  * @returns ICountryMask
  * */
  formatMask(masks: ICountryMask): ICountryMask {
    const { maskPhone, maskCityCode } = masks;
    return {
      ...masks,
      maskPhone: this.#replaceMaskTypeNumber(maskPhone),
      maskCityCode: this.#replaceMaskTypeNumber(maskCityCode),
    };
  }

  /*
  * Replace mask type number - 9 to 0 and, ; to || and - to ''
  * @param mask string
  * @returns string
  * */
  readonly #replaceMaskTypeNumber = (mask: string): string => mask?.replaceAll('9', '0').replaceAll(';', '||').replaceAll('-', '');

  /*
  * Check if city code is disabled by country
  * @param country string
  * @returns boolean
  * */
  readonly isDisabledCityCodeByCountry = (country: string): boolean => this.cityCodeDisabled.includes(country as COUNTRY_CODE);
}
